<!--
  @deprecated This offer modal is part of the old offer system that is being rebuilt.
  Do not use or modify this component.
-->
<template>
  <b-modal
    v-if="lobbyOffer"
    id="modal-offer-bailout-3"
    class="custom-modal1"
    :hide-footer="true"
    modal-class="custom-modal1"
    @hidden="onHidden"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <a href="#" class="close-button" @click="close()"> </a>
    </template>

    <template slot="default">
      <div v-if="rewards[0]" class="offer-reward-container1">
        <b-row class="h-100">
          <b-col cols="12">
            <BaseAsset
              asset="primary"
              size="big"
              style="width: 80px; height: 80px"
            />
          </b-col>
          <b-col
            cols="12"
            :style="{ visibility: rewards[0].gold > 0 ? 'visible' : 'hidden' }"
          >
            <div
              class="yellow-text bold"
              style="font-size: 36px"
              :class="rewards[0].gold.toString().length > 9 ? 'small' : ''"
            >
              {{ formatNumber(rewards[0].gold) }}
            </div>
          </b-col>

          <b-col cols="12">
            <b-row align-v="center" align-h="center" class="mx-3">
              <b-col v-if="rewards[0].crown > 0" cols="3" class="p-0">
                <BaseAsset asset="secondary" size="big" class="mb-2" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[0].crown) }} x
                </div>
              </b-col>
              <b-col v-if="rewards[0].card > 0" cols="3" class="p-0">
                <BaseAsset asset="cards" size="big" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[0].card) }} x
                </div>
              </b-col>

              <b-col v-if="rewards[0].loyalty > 0" cols="3" class="p-0">
                <BaseAsset asset="loyalty" size="big" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[0].loyalty) }} x
                </div>
              </b-col>

              <b-col v-if="rewards[0].elixir > 0" cols="3" class="p-0">
                <BaseAsset asset="tertiary" size="big" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[0].elixir) }} x
                </div>
              </b-col>

              <b-col v-if="rewards[0].expbooster > 0" cols="3" class="p-0">
                <BaseAsset asset="booster" size="big" />
                <div class="primary-accent">
                  {{ Math.round(rewards[0].expbooster / 60) }} Min.
                </div>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12" class="position-relative">
            <div class="submit-button" @click="buyItem(0, 'Offer', 'Bailout')">
              <div>
                {{ $t("shop.offers.buy_button", { 0: "" }) }}
                <br />
                <span class="big"
                  >{{ formatPrice(price[0]) }} €

                  <div
                    v-if="oldPrices && oldPrices[0]"
                    class="offer-old-price position-absolute"
                  >
                    {{ formatPrice(oldPrices[0]) }} €
                    <div class="offer-red-line to-center-abs"></div>
                  </div>
                  <div
                    v-if="moreContent && moreContent[0]"
                    class="big-badge-more-percent smaller"
                  >
                    <span class="big">{{ moreContent[0] }}</span>
                    {{ $t("shop.offers.more_contents2") }}
                  </div>
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div v-if="rewards[1]" class="offer-reward-container2">
        <b-row class="h-100">
          <div class="top-deal-text to-center-abs">Chance!</div>
          <b-col cols="12">
            <div class="icon-gold-container position-relative">
              <BaseAsset
                asset="primary"
                size="big"
                class="icon-gold1 to-center-abs"
              />
              <BaseAsset
                asset="primary"
                size="big"
                class="icon-gold2 to-center-abs"
              />
            </div>
          </b-col>
          <b-col
            cols="12"
            :style="{ visibility: rewards[1].gold > 0 ? 'visible' : 'hidden' }"
          >
            <div
              class="yellow-text bold"
              style="font-size: 40px"
              :class="rewards[1].gold.toString().length > 9 ? 'small' : ''"
            >
              {{ formatNumber(rewards[1].gold) }}
            </div>
          </b-col>

          <b-col cols="12">
            <b-row align-v="center" align-h="center" class="mx-3">
              <b-col v-if="rewards[1].crown > 0" cols="3" class="p-0">
                <BaseAsset asset="secondary" size="big" class="mb-2" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[1].crown) }} x
                </div>
              </b-col>
              <b-col v-if="rewards[1].card > 0" cols="3" class="p-0">
                <BaseAsset asset="cards" size="big" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[1].card) }} x
                </div>
              </b-col>

              <b-col v-if="rewards[1].loyalty > 0" cols="3" class="p-0">
                <BaseAsset asset="loyalty" size="big" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[1].loyalty) }} x
                </div>
              </b-col>

              <b-col v-if="rewards[1].elixir > 0" cols="3" class="p-0">
                <BaseAsset asset="tertiary" size="big" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[1].elixir) }} x
                </div>
              </b-col>

              <b-col v-if="rewards[1].expbooster > 0" cols="3" class="p-0">
                <BaseAsset asset="booster" size="big" />
                <div class="primary-accent">
                  {{ Math.round(rewards[1].expbooster / 60) }} Min.
                </div>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12" class="position-relative">
            <div class="submit-button" @click="buyItem(1, 'Offer', 'Bailout')">
              <div>
                {{ $t("shop.offers.buy_button", { 0: "" }) }}
                <br />
                <span class="big position-relative"
                  >{{ formatPrice(price[1]) }} €

                  <div v-if="oldPrices && oldPrices[1]" class="offer-old-price">
                    {{ formatPrice(oldPrices[1]) }} €
                    <div class="offer-red-line to-center-abs"></div>
                  </div>
                  <div
                    v-if="moreContent && moreContent[1]"
                    class="big-badge-more-percent smaller"
                  >
                    <span class="big">{{ moreContent[1] }}</span>
                    {{ $t("shop.offers.more_contents2") }}
                  </div>
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div v-if="rewards[2]" class="offer-reward-container3">
        <div
          v-if="moreContent && moreContent[2]"
          class="big-badge-more-percent"
        >
          <span class="big">{{ moreContent[2] }}</span>
          {{ $t("shop.offers.more_contents2") }}
        </div>
        <b-row class="position-relative">
          <div class="top-deal-text to-center-abs">
            {{ $t("shop.offers.top_deal") }}
          </div>
          <b-col cols="12">
            <img
              :src="$whitelabel.currencies.primary.triple"
              style="width: 250px"
            />
          </b-col>
          <b-col
            cols="12"
            :style="{ visibility: rewards[2].gold > 0 ? 'visible' : 'hidden' }"
          >
            <div
              class="bold yellow-text"
              style="font-size: 54px"
              :class="rewards[2].gold.toString().length > 9 ? 'small' : ''"
            >
              {{ formatNumber(rewards[2].gold) }}
            </div>
          </b-col>

          <b-col cols="12">
            <b-row align-v="center" align-h="center" class="mx-3">
              <b-col v-if="rewards[2].crown > 0" cols="3" class="p-0">
                <BaseAsset asset="secondary" size="big" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[2].crown) }} x
                </div>
              </b-col>
              <b-col v-if="rewards[2].card > 0" cols="3" class="p-0">
                <BaseAsset asset="cards" size="big" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[2].card) }} x
                </div>
              </b-col>

              <b-col v-if="rewards[2].loyalty > 0" cols="3" class="p-0">
                <BaseAsset asset="loyalty" size="big" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[2].loyalty) }} x
                </div>
              </b-col>

              <b-col v-if="rewards[2].elixir > 0" cols="3" class="p-0">
                <BaseAsset asset="tertiary" size="big" />
                <div class="primary-accent">
                  {{ formatNumber(rewards[2].elixir) }} x
                </div>
              </b-col>

              <b-col v-if="rewards[2].expbooster > 0" cols="3" class="p-0">
                <BaseAsset asset="booster" size="big" />
                <div class="primary-accent">
                  {{ Math.round(rewards[2].expbooster / 60) }} Min.
                </div>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12" class="position-relative">
            <div class="submit-button" @click="buyItem(2, 'Offer', 'Bailout')">
              <div>
                {{ $t("shop.offers.buy_button", { 0: "" }) }}
                <br />
                <span class="big position-relative"
                  >{{ formatPrice(price[2]) }} €

                  <div v-if="oldPrices && oldPrices[2]" class="offer-old-price">
                    {{ formatPrice(oldPrices[2]) }} €
                    <div class="offer-red-line to-center-abs"></div>
                  </div>
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </b-modal>
</template>

<script>
import offerModalContent from "@/mixins/offerModalContent.js";
import BaseAsset from "@/components/base/base-asset.vue";

export default {
  name: "ModalOfferBailout3",
  components: { BaseAsset },
  mixins: [offerModalContent],
  data() {
    return { isPipelineOffer: false };
  },
  mounted: function () {
    this.$bvModal.show("modal-offer-bailout-3");
  },
};
</script>
<style lang="scss">
$modal-width: 1000px;
$modal-height: 700px;

#modal-offer-bailout-3 {
  .modal-dialog {
    top: 50px;
    max-width: $modal-width;
    height: $modal-height;

    @media (max-height: 750px) {
      transform: scale(0.8);
      top: -60px;
      margin-bottom: -20%;
    }
  }

  .modal-content {
    width: $modal-width;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: bottom center;
    background-image: url("~@/assets/img/shop/offers/bailout-primary-3.png");
    background-color: transparent;
  }

  .close-button {
    top: -10px;
    right: 0px;
  }

  .offer-reward-container1 {
    top: 190px;
    height: 350px;
    line-height: 1.2;
    text-align: center;
    width: 300px;
    position: absolute;
    left: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .submit-button {
      width: 160px;
      height: 64px;
      background: url(~@/assets/img/shop/offers/btn-pay-secondary-offer.png)
        no-repeat;
      background-size: 100% 100%;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: white;
      text-transform: uppercase;
      cursor: pointer;
      font-family: Ubuntu-Bold;
      text-align: center;
      display: inline-flex;
      line-height: 1.1;
      margin-top: 10px;

      .big {
        color: white;
        font-family: Ubuntu-Bold;
        font-size: 30px;
      }

      .offer-old-price {
        position: absolute;
        top: 0;
        right: -12px;
      }
      .big-badge-more-percent {
        top: -250px;
        right: 0px;
      }
    }
  }

  .offer-reward-container2 {
    top: 180px;
    height: 363px;
    line-height: 1.2;
    text-align: center;
    width: 300px;
    position: absolute;
    right: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .top-deal-text {
      color: #7d3107;
      font-family: Ubuntu-Bold;
      font-size: 26px;
      text-transform: uppercase;
      text-align: center;
      text-shadow: 0 0 6px white, 0 0 6px white, 0 0 6px white, 0 0 5px white,
        0 0 2px white;
      top: -61px;
    }

    .icon-gold-container {
      height: 75px;

      .icon-gold1 {
        z-index: 1;
        right: -55px;
        width: 64px;
        height: 64px;
      }
      .icon-gold2 {
        z-index: 2;
        width: 80px;
        height: 80px;
        top: -15px;
        right: 20px;
      }
    }

    .submit-button {
      width: 200px;
      height: 72px;
      background: url(~@/assets/img/shop/offers/btn-pay-secondary-offer.png)
        no-repeat;
      background-size: 100% 100%;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: white;
      text-transform: uppercase;
      cursor: pointer;
      font-family: Ubuntu-Bold;
      text-align: center;
      display: inline-flex;
      line-height: 1.1;
      margin-top: 10px;

      .big {
        color: white;
        font-family: Ubuntu-Bold;
        font-size: 36px;
      }

      .offer-old-price {
        position: absolute;
        top: -55px;
        right: -100px;
      }
      .big-badge-more-percent {
        position: absolute;
        top: -330px;
        right: -130px;
      }
    }
  }

  .offer-reward-container3 {
    top: 110px;
    line-height: 1.2;
    text-align: center;
    width: 300px;
    position: absolute;
    left: 330px;
    height: 535px;
    .big-badge-more-percent {
      position: absolute;
      top: -55px;
      right: -88px;
    }

    .top-deal-text {
      color: #7d3107;
      font-family: Ubuntu-Bold;
      font-size: 33px;
      text-transform: uppercase;
      text-align: center;
      text-shadow: 0 0 6px white, 0 0 6px white, 0 0 6px white, 0 0 5px white,
        0 0 2px white;
      top: -64px;
    }

    .submit-button {
      width: 352px;
      height: 182px;
      background: url(~@/assets/img/shop/offers/btn-offer-green.png) no-repeat;
      background-size: 100% 100%;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: white;
      text-transform: uppercase;
      cursor: pointer;
      font-family: Ubuntu-Bold;
      text-align: center;
      display: inline-flex;
      line-height: 1;

      .big {
        color: white;
        font-family: Ubuntu-Bold;
        font-size: 48px;
      }
      .offer-old-price {
        position: absolute;

        top: -35px;
        right: -140px;
      }
    }
  }
}
</style>
